import React from "react";

import {
  Container,
  Row,
  Col,
} from "reactstrap";

function Background() {
  return (
    <section>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto text-center my-5" md="8">
            <h3 className="display-3 text-info">Company Culture</h3>
            <p className="lead font-weight-bold text-default">
              At CrypTegridy, we foster a culture of integrity, collaboration, 
              and continuous learning. Our team is composed of dedicated professionals 
              who are passionate about protecting our clients and staying ahead of 
              emerging threats. We value transparency, ethical practices, and 
              innovation, ensuring that we remain committed to delivering 
              exceptional intelligence services.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Background;
